<div class="children-selector-header">
  <app-children-selector (studentSelected)="onStudentSelected($event)"></app-children-selector>
</div>

<main class="wrap">
  <section class="ask-isalni" aria-label="E-class section">

    <!-- LEFT: Séances List Container -->
    <div class="ask-form" aria-label="Liste des séances">
      
      <h2>E-class</h2>
      <p class="form-subtitle">
        Consultez et rejoignez les séances virtuelles et cours en direct pour {{ selectedStudent?.nameStudent || 'votre enfant' }}.
      </p>

      <!-- Loading Indicator -->
      <div *ngIf="isLoading" class="loading-indicator">
        <div class="spinner"></div>
        <p>Chargement des séances en cours...</p>
      </div>

      <!-- Error / Empty State -->
      <div *ngIf="!isLoading && seances.length === 0" class="response-area">
        <h3>Aucune séance disponible</h3>
        <p>Il n'y a pas de séance en ligne programmée pour le moment pour cet élève.</p>
      </div>

      <!-- Séances Cards List -->
      <div *ngIf="!isLoading && seances.length > 0" class="seances-container">
        <article *ngFor="let seance of seances" class="seance-item-card">
          
          <!-- Card Top Header -->
          <div class="seance-header">
            <div class="seance-title-group">
              <span class="org-tag" *ngIf="seance.nameorg">{{ seance.nameorg }}</span>
              <h3 class="seance-title">{{ seance.nom }}</h3>
              <span class="classe-badge">{{ seance.classeNom }}</span>
            </div>

            <!-- Status Badge -->
            <span class="status-pill" [ngClass]="getStatusClass(seance.statut)">
              <span class="status-dot" *ngIf="seance.statut === 'EN_COURS'"></span>
              {{ getStatusLabel(seance.statut) }}
            </span>
          </div>

          <!-- Card Details Grid -->
          <div class="seance-body">
            <div class="info-row">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                </svg>
              </div>
              <div class="info-text">
                <span class="info-label">Horaire</span>
                <span class="info-value">{{ formatTimeRange(seance.dateDebut, seance.dateFin) }}</span>
              </div>
            </div>

            <div class="info-row">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <div class="info-text">
                <span class="info-label">Enseignant(s)</span>
                <span class="info-value">{{ formatTeachers(seance.enseignants) }}</span>
              </div>
            </div>

            <div class="info-row" *ngIf="seance.jitsiPassword">
              <div class="info-icon">
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                </svg>
              </div>
              <div class="info-text">
                <span class="info-label">Mot de passe réunion</span>
                <span class="info-value code-box">{{ seance.jitsiPassword }}</span>
              </div>
            </div>
          </div>

          <!-- Card Action Button -->
          <div class="seance-footer">
            <button 
              class="submit-button" 
              (click)="openJitsiModal(seance)">
              <span>JOINDRE LA SÉANCE</span>
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
              </svg>
            </button>
          </div>

        </article>
      </div>

    </div>

    <!-- RIGHT: Illustration Feature Cards (Isalni Style 2x2 grid) -->
    <aside class="illustration-cards" aria-label="E-class fonctionnalités">

      <!-- Card 1 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
          </svg>
        </div>
        <h3>Visio en Direct</h3>
        <p>Rejoignez instantanément les salles de cours virtuelles Jitsi.</p>
      </article>

      <!-- Card 2 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
          </svg>
        </div>
        <h3>Suivi Enseignant</h3>
        <p>Enseignants qualifiés et assistance en temps réel.</p>
      </article>

      <!-- Card 3 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2z"/>
          </svg>
        </div>
        <h3>Salles Sécurisées</h3>
        <p>Accès protégé avec mots de passe et liens uniques.</p>
      </article>

      <!-- Card 4 -->
      <article class="card" role="group">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2z"/>
          </svg>
        </div>
        <h3>Planning interactif</h3>
        <p>Consultation claire des horaires et de la durée des cours.</p>
      </article>

    </aside>
  </section>
</main>

<div class="float-blob" aria-hidden="true"></div>

<!-- Jitsi Video Class Modal Overlay -->
<div *ngIf="showJitsiModal" class="jitsi-modal-backdrop" (click)="closeJitsiModal()">
  <div class="jitsi-modal-dialog" (click)="$event.stopPropagation()">
    <div class="jitsi-modal-header">
      <div class="modal-title-box">
        <span class="live-dot-badge"></span>
        <h3>{{ activeModalSeance?.nom }} - En Direct</h3>
      </div>
      <button class="modal-close-btn" (click)="closeJitsiModal()">&times;</button>
    </div>

    <div class="jitsi-modal-body">
      <div class="jitsi-info-bar" *ngIf="activeModalSeance">
        <span><strong>Classe:</strong> {{ activeModalSeance.classeNom }}</span>
        <span><strong>Enseignant:</strong> {{ formatTeachers(activeModalSeance.enseignants) }}</span>
        <span *ngIf="activeModalSeance.jitsiPassword">
          <strong>Mot de passe:</strong> <code class="pass-code">{{ activeModalSeance.jitsiPassword }}</code>
        </span>
      </div>

      <!-- Iframe Jitsi stream -->
      <div class="iframe-container" *ngIf="safeJitsiUrl">
        <iframe 
          [src]="safeJitsiUrl" 
          allow="camera; microphone; display-capture; autoplay; clipboard-write; encrypted-media" 
          class="jitsi-iframe">
        </iframe>
      </div>
    </div>

    <div class="jitsi-modal-footer">
      <button 
        class="external-link-btn" 
        *ngIf="activeModalSeance?.jitsiLink" 
        (click)="openExternalJitsi(activeModalSeance!.jitsiLink)">
        Ouvrir dans Jitsi Meet (Nouvel onglet)
      </button>
      <button class="close-modal-btn" (click)="closeJitsiModal()">Fermer</button>
    </div>
  </div>
</div>
